import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IClientOriginHostEditorProps {
    value: string;
    onUpdate: (field: 'originHost', value: string) => void;
}

export default function ClientOriginHostEditor({ value = '', onUpdate }: IClientOriginHostEditorProps) {
    const { t } = useTranslation();
    return (
        <TextField
            fullWidth
            label={t('common:organization.projects.originHost.title')}
            value={value}
            placeholder={'https://abcd.com'}
            onChange={(e) => onUpdate('originHost', e.target.value)}
        />
    );
}
